export const table = [
    {
        column: 'Título',
    },
    {
        column: 'Respostas',
    },
];

export const keys = ['title', 'total_answers'];
